
import type { BaseContainerProps } from '.'
import { FormSection } from '../../../../forms/FormSection'
import { InsureeForm } from '../forms/InsureeForm'

export const Insuree = (props: BaseContainerProps) => {
  return (
    <FormSection {...props}>
      <InsureeForm />
    </FormSection>
  )
}